import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Home from "./pages/Home";
import JavaSnippetPage from "./pages/JavaSnippetPage";
import BlogList from "./pages/BlogList";
import BlogPage from "./pages/BlogPage";

function App() {
  return (
    <div className="min-h-screen bg-white text-black dark:bg-gray-900 dark:text-white">
 
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/java-snippet" element={<JavaSnippetPage />} />
        <Route path="/blogs" element={<BlogList />} />
        <Route path="/blogs/:slug" element={<BlogPage />} />
      </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
